import { render, staticRenderFns } from "./StarlineTab.vue?vue&type=template&id=40dd36fa&scoped=true"
import script from "./StarlineTab.vue?vue&type=script&lang=js"
export * from "./StarlineTab.vue?vue&type=script&lang=js"
import style0 from "./StarlineTab.vue?vue&type=style&index=0&id=40dd36fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dd36fa",
  null
  
)

export default component.exports